export default {
  devbridgeLunch: 'Devbridge Pietūs',
  succesfullySaved: 'Sėkmingai išsaugota',
  succesfullySavedBody: 'Patiekalai sėkmingai įrašyti mūsų sistemoje.',
  dishes: ' patiekalai',
  copyFromOtherDay: 'Kopijuoti iš kitos dienos',
  nextDay: 'Kita Diena',
  previousDay: 'Praėjusi Diena',
  submit: 'Pateikti Patiekalus',
  nothingFound: 'Nieko nerasta',
  nothingFoundBody: 'Patikrinkite ar adresas tikrai geras.',
  monday: 'Pirmadienio',
  tuesday: 'Antradienio',
  wednesday: 'Trečiadienio',
  thursday: 'Ketvirtadienio',
  friday: 'Penktadienio',
  soups: 'Sriubos',
  soupsWithCount: 'Sriubos ({count})',
  mains: 'Pagrindiniai patiekalai',
  mainsWithCount: 'Pagrindiniai patiekalai ({count})',
  dishesWithCount: '{count} Patiekalas (-ai)',
  noDishes: 'Patiekalų neįvesta',
  formError: 'Įvestuose patiekaluose rasta klaidų arba ne visi laukai buvo užpildyti.',
  savingError: 'Išsaugant įvyko klaida. Patikrinkite duomenis ir bandykite iš naujo.',
  price: 'Kaina',
  dishName: 'Patiekalo Pavadinimas',
};
